<div
  class="
    col-xs-12 col-sm-12 col-md-12
    Registration-split
    recovery-split
    border-align
  "
  >
  <h3 class="login-help-title">
    {{ "passwordRecoveryFailure.assistanceTitle" | cxTranslate }}
  </h3>
  @if (baseSiteId == 'vsh') {
    <span class="security-Notify">
      We couldn’t find your customer information in our database. Please call us
      at 1-800-VACCINE (1-800-822-2463).
    </span>
  }
  @if (baseSiteId == 'vax') {
    <span class="security-Notify">
      We couldn’t find your customer information in our database. Please call us
      at 1-800-752-9338.
    </span>
  }
  <div class="col-xs-12 col-sm-8 col-md-12 p0">
    <div class="col-xs-12 col-sm-12 col-md-12 p0 Fields-container">
      <label class="Fields-label">{{
        "forgotUserPassword.emailAddress" | cxTranslate
      }}</label>
      <span class="recovery-common-txt">{{ userAgentData?.email }}</span>
    </div>
  </div>
  <br />
</div>
